import { AssetMasterModule } from "@/store/modules/asset.module";
import { assign, Machine } from "xstate";
const assetAssessmentYearMachine = Machine({
    id: "assetAssessmentYearMachine",
    context: {
        searchData: {
            page: 1,
            pageSize: 10,
            sort: {
                field: "startingDate",
                type: "asc",
            },
            columnFilters: [],
        },
    },
    initial: "idle",
    states: {
        idle: {
            always: {
                target: "gettingAssetAssessmentYears",
            },
        },
        gettingAssetAssessmentYears: {
            tags: "processing",
            invoke: {
                id: "gettingAssetAssessmentYears",
                src: (context, event) => {
                    return AssetMasterModule.GetAssetAssessmentYears(context.searchData);
                },
                onDone: { target: "loadedAssetAssessmentYears" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedAssetAssessmentYears: {
            on: {
                GETTING_ASSET_ASSESSMENT_YEAR: { target: "gettingAssetAssessmentYears", actions: "assignSearchData" },
                RUN_DEPRECIATION_CALCULATION: { target: "runDepreciationCalculation" },
                EXPORT_DEPRECIATION_EXCEL: { target: "exportAssetDepreciation" },
            },
        },
        runDepreciationCalculation: {
            tags: "processing",
            invoke: {
                id: "runDepreciationCalculation",
                src: (context, event) => {
                    return AssetMasterModule.RunAssetsDepreciation(event.assessmentYearId);
                },
                onDone: { target: "gettingAssetAssessmentYears" },
                onError: { target: "serviceUnavailable" },
            },
        },
        exportAssetDepreciation: {
            invoke: {
                id: "exportAssetDepreciation",
                src: (context, event) => {
                    return AssetMasterModule.AssetDepreciationReportAsExcel(event.assessmentYearId);
                },
                onDone: { target: "gettingAssetAssessmentYears", actions: "downLoadExcelReport" },
                onError: { target: "serviceUnavailable" },
            },
        },
        serviceUnavailable: {
            type: "final",
        },
    },
}, {
    actions: {
        assignSearchData: assign({
            searchData: (context, event) => event.searchData,
        }),
        downLoadExcelReport: (context, event) => {
            const blob = new Blob([AssetMasterModule.pdfData], { type: "application/pdf" });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.download = `Asset Depreciation Report ${AssetMasterModule.assessmentReportYear}.xlsx`;
            link.click();
        },
    },
    guards: {},
    activities: {},
    services: {},
});
export default assetAssessmentYearMachine;
